export default {
  setDrawer: (state, value) => (state.drawer = value),
  setMenu: (state, value) => (state.menu = value),
  setSubMenu: (state, value) => (state.sub_menu = value),
  setImage: (state, value) => (state.image = value),
  setColor: (state, value) => (state.color = value),
  toggleMenu: (state) => (state.menu = !state.menu),
  toggleDrawer: (state) => (state.drawer = !state.drawer),
}
